import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUnreadTotal } from '@/hooks/useUnreadTotal'
import { toast } from '@/lib/toast'

export function NewMessageToastListener() {
  const { data: unreadTotal = 0 } = useUnreadTotal()
  const previousTotal = useRef<number | null>(null)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (previousTotal.current === null) {
      previousTotal.current = unreadTotal
      return
    }

    if (
      unreadTotal > previousTotal.current &&
      !location.pathname.startsWith('/chat')
    ) {
      const newCount = unreadTotal - previousTotal.current
      toast.info(
        `You have ${newCount} new message${newCount > 1 ? 's' : ''}`
      )
      // Note: the existing toast system doesn't support action buttons,
      // but the toast will draw attention to navigate to /chat via the nav badge
    }
    previousTotal.current = unreadTotal
  }, [unreadTotal, location.pathname, navigate])

  return null
}
